import Svg, { SvgProps } from './Svg';

export default function SPKIcon({ ...props }: SvgProps) {
  const id1 = 'linearGradient-spk' + Math.random().toString(16).slice(2);
  return (
    <Svg viewBox="0 0 114 116" fill="none" {...props}>
      <path
        d="M113.823 57.7612C113.823 88.7234 88.7232 113.823 57.761 113.823C26.7988 113.823 1.69904 88.7234 1.69904 57.7612C1.69904 26.799 26.7988 1.69922 57.761 1.69922C88.7232 1.69922 113.823 26.799 113.823 57.7612Z"
        fill={`url(#${id1})`}
      />
      <path
        d="M68.4208 62.8496H99.9924C101.221 62.8496 101.585 61.1768 100.468 60.666L68.415 46.0083L68.415 13.8915C68.415 12.6946 66.8092 12.3019 66.2569 13.3637L52.952 38.9387L38.0957 32.1712C37.1091 31.7219 36.1093 32.7693 36.604 33.7339L45.8865 51.8321L14.3137 51.8321C13.0853 51.8321 12.7209 53.5047 13.838 54.0157L45.8923 68.6777L45.8923 100.79C45.8923 101.987 47.4981 102.38 48.0505 101.318L61.3542 75.7452L76.1868 82.5247C77.1728 82.9754 78.174 81.9293 77.6805 80.9641L68.4208 62.8496Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id={id1}
          x1="102.512"
          y1="10.1935"
          x2="9.1409"
          y2="101.149"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#FA43BD" />
          <stop offset="1" stopColor="#FFA930" />
        </linearGradient>
      </defs>
    </Svg>
  );
}
